var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInstagramLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 43,
    viewBox: "0 0 42 43",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.966 1.6762H11.6816C5.78175 1.6762 1 6.4588 1 12.3578V30.6422C1 36.542 5.7826 41.3238 11.6824 41.3238H29.9652C35.865 41.3238 40.6476 36.5412 40.6476 30.6414V12.3578C40.6476 6.45795 35.865 1.6762 29.9652 1.6762H29.966Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8237 31.0704C26.1092 31.0704 30.394 26.7857 30.394 21.5002C30.394 16.2146 26.1092 11.9299 20.8237 11.9299C15.5382 11.9299 11.2534 16.2146 11.2534 21.5002C11.2534 26.7857 15.5382 31.0704 20.8237 31.0704Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4446 11.93C33.5771 11.93 34.4951 11.0119 34.4951 9.87944C34.4951 8.74696 33.5771 7.8289 32.4446 7.8289C31.3121 7.8289 30.394 8.74696 30.394 9.87944C30.394 11.0119 31.3121 11.93 32.4446 11.93Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramLogo);
export default __webpack_public_path__ + "static/media/instagram-logo.802da22c2f8fa3a4d69e3a6caf351945.svg";
export { ForwardRef as ReactComponent };